// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function handleTabEntreCampos(
  e: React.KeyboardEvent<HTMLInputElement>,
  campo: string,
  grupo: string,
) {
  if (e.key !== 'Tab' || e.shiftKey) {
    return;
  }

  const inputs = Array.from(
    document.querySelectorAll<HTMLInputElement>(
      `input[data-tab-group="${grupo}"][data-tab-field="${campo}"]`,
    ),
  );

  const indexAtual = inputs.indexOf(e.currentTarget);

  if (indexAtual === -1) {
    return;
  }

  const proximoInput = inputs[indexAtual + 1];

  if (proximoInput) {
    e.preventDefault();
    proximoInput.focus();
    proximoInput.select();
  }
}
